export function getCoords(e, element, zoomLevel = 1) {
  const bounds = element.getBoundingClientRect();
  const pinSize = 30;

  // Get the click position relative to the element
  const relativeX = e.clientX - Math.round(bounds.left);
  const relativeY = e.clientY - Math.round(bounds.top);

  // Adjust for zoom by dividing by the zoom level
  const adjustedX = relativeX / zoomLevel;
  const adjustedY = relativeY / zoomLevel;

  const unscaledWidth = bounds.width / zoomLevel;
  const unscaledHeight = bounds.height / zoomLevel;

  return {
    x: {
      size: ((adjustedX - pinSize / 2) / unscaledWidth) * 100,
      unit: '%',
    },
    y: {
      size: ((adjustedY - pinSize / 2) / unscaledHeight) * 100,
      unit: '%',
    },
  };
}

export function getNotableElement(target) {
  let element = target;

  const voidElements = [
    'area',
    'base',
    'br',
    'col',
    'hr',
    'input',
    'svg',
    'link',
    'meta',
    'param',
    'source',
    'track',
    'wbr',
  ];
  const replacedElements = ['audio', 'canvas', 'embed', 'iframe', 'img', 'math', 'object', 'picture', 'video'];

  const elementBlacklist = [...voidElements, ...replacedElements];

  while (elementBlacklist.includes(element.tagName.toLowerCase()) || element.closest('svg')) {
    element = element.parentElement;
  }

  return element;
}

export function formatRelativeTime(date) {
  const formatter = new Intl.RelativeTimeFormat('en', {
    numeric: 'auto',
  });

  const units = [
    { amount: 60, name: 'seconds' },
    { amount: 60, name: 'minutes' },
    { amount: 24, name: 'hours' },
    { amount: 7, name: 'days' },
    { amount: 4.34524, name: 'weeks' },
    { amount: 12, name: 'months' },
    { amount: Number.POSITIVE_INFINITY, name: 'years' },
  ];

  const formatTime = (inputDate) => {
    const dateObj = new Date(inputDate);
    let duration = (dateObj - new Date()) / 1000;

    for (const unit of units) {
      if (Math.abs(duration) < unit.amount) {
        return formatter.format(Math.round(duration), unit.name);
      }
      duration /= unit.amount;
    }
  };

  return formatTime(date);
}

export const exportTableToCSV = (
  columns,
  filteredData,
  allData,
  mode,
  fileName = 'export.csv'
) => {
  const rows = mode === 'filtered' ? filteredData : allData;

  if (!rows || rows.length === 0) {
    alert('No data to export');
    return;
  }

  const exportableColumns = columns.filter(
    (col) => col.dataIndex && col.dataIndex !== 'actions'
  );

  const headers = exportableColumns.map((col) => col.title);

  const csvRows = rows.map((row) => {
    return exportableColumns.map((col) => {
      const value = row[col.dataIndex];

      if (value === null || value === undefined) return '';

      return `"${String(value).replace(/"/g, '""')}"`;
    }).join(',');
  });

  const csvContent = [
    headers.join(','),
    ...csvRows
  ].join('\n');

  // download file
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};